import Image from 'next/image';
import Link from 'next/link';
import { ctaLarge, ctaOverlayLarge } from '../assets/images';
import { CheckMark } from '../assets/icons';

const BottomImage = ({ path }) => {
  return (
    <div className='main'>
      <Image
        src={ctaLarge}
        quality={80}
        layout='fill'
        objectFit='cover'
        //objectPosition='center center'
        alt='image'
      />
      <div className='contentBtmImg'>
        {' '}
        <h3 className='headingContent'>
          Start your personal consultation today
        </h3>
        <h3 className='headingContentLg'>
          Start your personal <br />
          consultation today
        </h3>
        <ul className='ctaList'>
          {ctaGoals.map((item) => (
            <li key={item.id} className='ctaListStyle'>
              <span>
                <CheckMark />
              </span>
              {item.text}
            </li>
          ))}
        </ul>
        <Link href={`${path ? path : '/services'}`}>
          <span className='startTreatmentBtn'>Start Treatment now</span>
        </Link>
      </div>
      <div className='mobileImageContainer'>
        <Image
          src={ctaOverlayLarge}
          quality={80}
          layout='fill'
          objectFit='contain'
          alt='image'
        />
      </div>
    </div>
  );
};

export default BottomImage;
const ctaGoals = [
  { id: 1, text: 'Choose your condition or take our quick quiz if unsure.' },
  { id: 2, text: ' Get personalized treatment/medication right away.' },
  { id: 3, text: 'Quick, easy, and affordable & 100% online.' },
];
//   style={{
//     margin: '0',
//     padding: '0',
//     listStyleType: 'none',
//     color: '#FFFFFF',
//     fontSize: '0.875rem',
//     fontWeight: '500',
//     lineHeight: '1.25rem',
//   }}
